<template>
  <div>
    <section-title
      content="III. Información Relevante del Historial General, al Proceso de Evaluación en AT (continuación)"
      :has-line="true"
    />
    <section-title
      content="Servicios Relacionados que recibe el estudiante"
      :has-line="false"
      icon="far fa-info-circle"
      bgIcon="bg-white"
      containerClass="tag-badge-info-custom"
    />
    <custom-callout
      :key="index"
      v-for="(item, index) in list"
      class="mt-4 custom-callout"
      :has-toggle="false"
    >
      <div class="row bg-gray p-4 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Servicio:
          </div>
          <div class="color-black font-16 ">
            {{ item.disciplineName | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Modalidad:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.modalityName | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Frecuencia:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.frequencyName | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Duración:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.durationName | empty }}
          </div>
        </div>
      </div>
    </custom-callout>
    <div class="row mt-4">
      <div class="col-12">
        <div>
          <label class="color-secondary-6 font-weight-normal mr-2 font-16">
            Equipo adaptado u ortopédico:
          </label>
        </div>
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.adaptedOrthopedicEquipment"
            class="mb-2"
            :count-classes="['d-block text-right']"
            custom-error-msg="Este campo es requerido"
            :error="errors[0] ? 'err' : ''"
            :maxlength="3000"
            :show-char-count="true"
            placeholder="Comentario"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12">
        <div>
          <label class="color-secondary-6 font-weight-normal mr-2 font-16">
            Expectativas de los padres:
          </label>
        </div>
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.parentExpectations"
            class="mb-2"
            :count-classes="['d-block text-right']"
            custom-error-msg="Este campo es requerido"
            :error="errors[0] ? 'err' : ''"
            :maxlength="3000"
            :show-char-count="true"
            placeholder="Comentario"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12">
        <div>
          <label class="color-secondary-6 font-weight-normal mr-2 font-16">
            Expectativas del estudiante:
          </label>
        </div>
        <Checkbox
          :disabled-bg-color="'bg-dark-gray'"
          :checked-bg-color="'bg-success'"
          :icon="'fal fa-check'"
          v-model="model.notApply"
          class="my-2"
          text="No Aplica"
          :disabled="isReadOnly"
          @input="handlerClearComment"
        />
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          v-if="!model.notApply"
        >
          <custom-text-area
            v-model="model.studentExpectations"
            class="mb-2"
            :count-classes="['d-block text-right']"
            custom-error-msg="Este campo es requerido"
            :error="errors[0]"
            :maxlength="3000"
            :show-char-count="true"
            placeholder="Comentario"
            :disabled="isReadOnly"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import CustomTextArea from '@quisit/custom-text-area';
import Checkbox from 'CheckBox';
export default {
  name: 'GeneralHistory',
  components: {
    SectionTitle,
    CustomCallout,
    CustomTextArea,
    Checkbox,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    handlerClearComment(value) {
      if (value) {
        this.model.studentExpectations = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .title-icon {
  color: #ff7058 !important;
  font-size: 1.3rem !important;
  margin: 3.6px !important;
}

::v-deep .tag-badge-info-custom {
  background: linear-gradient(90deg, #fff0e1 24.8%, #ffffff 82%) !important;
}
</style>
